import {
    RETRIEVE_LOCAL_DATA,
    SET_LOCAL_DATA
} from '../types';

export function retrieve() {
    return { type: RETRIEVE_LOCAL_DATA };
}

export function set(key, value, asyncKey, cb) {
    if (!asyncKey) asyncKey = key;
    return function (dispatch) {
        let item = localStorage.getItem(asyncKey);
        item = JSON.parse(item);
        let newData = { ...item, ...value };
        localStorage.setItem(asyncKey, JSON.stringify(newData));
        dispatch({ type: SET_LOCAL_DATA, payload: { key, value: newData } });
        if (cb) cb();
    };
}



// WEBPACK FOOTER //
// ./src/actions/local-storage-actions.js